var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Controller } from 'react-hook-form';
import { RawCodeEditor } from './RawCodeEditor.js';
export const FormCodeEditor = (_a) => {
    var { control, register: _, name, value: __, defaultLanguage } = _a, rest = __rest(_a, ["control", "register", "name", "value", "defaultLanguage"]);
    return (React.createElement(Controller, { control: control, name: name, render: ({ field: { onChange, value }, fieldState: { error } }) => (React.createElement("div", null,
            React.createElement(RawCodeEditor, Object.assign({ name: name, onChange: onChange, value: value, defaultLanguage: defaultLanguage, error: error }, rest)))) }));
};
//# sourceMappingURL=FormCodeEditor.js.map